import React, { useState } from 'react';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useSnackbar } from 'notistack';
import { exportXlsx, exportFilteredCsv } from './exportHelpers';

export default function ExportButton({
    variant = 'csv',
    label = 'Export',
    filters,
    extraAndFilter,
    extraOrFilter,
    fileName,
    sheets,
    color = 'primary',
    size = 'small',
    sx,
    buttonStyle = 'outlined',
    bgColor,
    textColor = '#fff',
    appointmentRequired = true,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const onClick = async () => {
        if (variant === 'xlsx') {
            try {
                exportXlsx(fileName || 'Export', sheets || []);
                enqueueSnackbar('Export ready', { variant: 'success' });
            } catch (e) {
                enqueueSnackbar(e?.message || 'Export failed', { variant: 'error' });
            }
            return;
        }
        setLoading(true);
        try {
            await exportFilteredCsv({ filters, extraAndFilter, extraOrFilter, fileName, enqueueSnackbar, appointmentRequired });
        } catch (e) {
            enqueueSnackbar(e?.message || 'Export failed', { variant: 'error' });
        }
        setLoading(false);
    };

    const containedSx = bgColor
        ? { bgcolor: bgColor, color: textColor, '&:hover': { bgcolor: bgColor, opacity: 0.9 }, ...(sx || {}) }
        : sx;

    if (variant === 'csv') {
        return (
            <LoadingButton
                loading={loading}
                variant={buttonStyle}
                size={size}
                color={color}
                startIcon={<FileDownloadOutlinedIcon />}
                onClick={onClick}
                sx={containedSx}
            >{label}</LoadingButton>
        );
    }
    return (
        <Button
            variant={buttonStyle}
            size={size}
            color={color}
            startIcon={<FileDownloadOutlinedIcon />}
            onClick={onClick}
            sx={containedSx}
        >{label}</Button>
    );
}
